/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guarantee_StatementInputs */

const et_guarantee_statement = /** @type {(inputs: Guarantee_StatementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GARANTII: Kui me ei suuda tõsta teie päringute arvu esimese 90 päevaga, töötame edasi tasuta, kuni eesmärk on täidetud.`)
};

const en_guarantee_statement = /** @type {(inputs: Guarantee_StatementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GUARANTEE: If we can't increase your inquiries within the first 90 days, we'll keep working for free until the goal is met.`)
};

/**
* | output |
* | --- |
* | "GUARANTEE: If we can't increase your inquiries within the first 90 days, we'll keep working for free until the goal is met." |
*
* @param {Guarantee_StatementInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const guarantee_statement = /** @type {((inputs?: Guarantee_StatementInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guarantee_StatementInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_guarantee_statement(inputs)
	return en_guarantee_statement(inputs)
});